export default "__VITE_ASSET__BNIsqBt1__"